import firebase from "firebase/app";
import 'firebase';

export const auth = firebase.initializeApp({
    apiKey: process.env.REACT_APP_FIREBASE_KEY,
    authDomain: process.env.REACT_APP_CHAT_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_CHAT_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSEGING_SENDING_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
  }).auth();